import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ArrowRight from '@material-ui/icons/ArrowRightAlt'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { useNavigate } from "react-router-dom";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import $ from "jquery";
import { lookupCFP, lookupRoles, lookupTrainings, lookupYard } from '../common/commonJson';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {

        marginLeft: 240,
    },
    drawer: {
        width: '100%',
        flexShrink: 0,
    },
    drawerPaper: {
        width: 100,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        boxShadow: "none !important",
        border: "1px solid #F1F1F1",

    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
    },
}));

const SidebarMasterData = () => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);
    const [isMobile, setisMobile] = React.useState();
    const [value, setValue] = React.useState(0);
    const [more, setMore] = React.useState(true);
    const [less, setLess] = React.useState(true);
    const [plan, setPlan] = React.useState(true);
    const [add, setAdd] = React.useState(true);
    const navigate = useNavigate();

    const MasterDataNavigation = (e, str) => {
        $("#closemodal").trigger("click")
        $("#closemodal1").trigger("click")
        $(".naviIcon").removeClass("d-block");
        $(".naviIcon").addClass("d-none");
        $("#" + str).removeClass("d-none");
        $("#" + str).addClass("d-block");
        $(".textNaviIcon .MuiListItemText-primary").removeClass("fw-bolder");
        $("#" + str + "1 .MuiListItemText-primary").addClass("spanTopBar");
        e === 1 ? navigate("/lookupdata/opa") :
            e === 2 ? navigate("/lookupdata/pcp") :
                e === 3 ? navigate("/lookupdata/dwp") :
                    e === 4 ? navigate("/lookupdata/iados") :
                        e === 5 ? navigate("/masterdata/drohm") :
                            e === 6 ? navigate("/masterdata/mom") :
                                e === 7 ? navigate("/lookupdata/status") :
                                    e === 8 ? navigate(lookupYard) :
                                        e === 9 ? navigate(lookupRoles) :
                                            e === 10 ? navigate(lookupTrainings) : 
                                                 e === 11 ? navigate(lookupCFP) : navigate("");
    };

    useEffect(() => {
        window.addEventListener('resize', resize);
        const interval = setInterval(() => {
            resize()
        }, 100);
        return () => clearInterval(interval);
    }, []);

    const resize = () => {
        if (window.innerWidth < 850) { setisMobile(true) }
        else { setisMobile(false) }
        $("#MASOperation1 .MuiListItemText-primary").addClass("spanTopBar");
    };

    return (
        <>
            {isMobile ?
                <div className={classes.root}>
                    <CssBaseline />
                    <List className="pt-4 mt-5 w-100 " style={{ backgroundColor: "#F6F6F6", height: "calc(100vh)", width: 240, bottom: 0 }} >
                        <ListItem className='border-bottom' >
                            <ListItemText id={"MASOperation" + "1"} className='pl-3 textNaviIcon fw-bolder' primary="Master Data" />
                            <NavigateBeforeIcon id="MASOperation" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem>
                        {['Operation Planning & Acheivement', 'Pre Cutting Progress', 'Daily Work Progress', 'Initial Audit & Daily Observation Status', 'Disposition Records of Hazardous Materials', 'Matrix Of Materials', 'Status', 'Yards', 'Roles', 'Trainings', 'Carbon Foot print & GHG Reduction'].map((text, index) => (
                            <ListItem className="" button key={text} onClick={() => { MasterDataNavigation(index + 1, text.replaceAll(" ", "")) }}>
                                <ListItemText className="px-3 textNaviIcon" id={text.replaceAll(" ", "") + "1"} primary={text} />
                                <NavigateNextIcon className="naviIcon d-none" id={text.replaceAll(" ", "")} style={{ width: 23, height: 23 }} />
                            </ListItem>
                        ))}
                    </List>
                </div>
                : navigate('/lookupdata/opa')
            }
        </>
    )
}
export default SidebarMasterData;